import { render, staticRenderFns } from "./Verzorging.vue?vue&type=template&id=675aea74&scoped=true"
import script from "./Verzorging.vue?vue&type=script&lang=js"
export * from "./Verzorging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675aea74",
  null
  
)

export default component.exports